module.exports = __webpack_public_path__ + "img/zp-track-logo.4131b0b9.png";